const UPSCALE_MODEL = 'upscale';
const MAGIC_FILL_MODEL = 'magic-fill';
const REMOVE_OBJECTS_MODEL = 'remove-objects';
const PHOTO_GEN_MODEL = 'photo-gen';
const REMOVE_BG_MODEL = 'remove-bg';
const REMIX_MODEL = 'remix';
export { UPSCALE_MODEL, REMIX_MODEL, MAGIC_FILL_MODEL, REMOVE_OBJECTS_MODEL, PHOTO_GEN_MODEL, REMOVE_BG_MODEL };
